import React from "react";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import "./style.less";

const style = {
  textIndent: "2em",
};

const App = () => {
  const [[{ title = "Cloud Exhibition Hall", show, hide, width = 700 }]] =
    useWatchState(["modal.protocolHZ"]);

  return (
    <Modal
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      onCancel={hide}
      footer={false}
    >
      <div className="child-top-sm">
        <p style={style}>
          This application respects and protects the personal privacy of all
          service users. In order to provide you with more accurate and
          personalized services, this application will use and disclose your
          personal information in accordance with the provisions of this privacy
          policy. However, this application will treat this information with a
          high degree of diligence and prudence. Except as otherwise provided in
          this privacy policy, this application will not disclose or provide
          this information to third parties without your prior permission. This
          application will update this privacy policy from time to time. When
          you agree to this application service use agreement, you are deemed to
          have agreed to the entire content of this privacy policy. This privacy
          policy is an integral part of this application service usage
          agreement.
        </p>
        <p style={style} className="bold self-top--little">
          1. Scope of application
        </p>
        <p style={style}>
          (1) When you register for this application account, you provide
          personal registration information according to the requirements of
          this application;
        </p>
        <p style={style}>
          (2) When you use this application network service or visit the
          application platform webpage, this application automatically receives
          and records the information on your browser and computer, including
          but not limited to your IP address, browser type, Data such as the
          language used, the date and time of the visit, the characteristics of
          software and hardware, and the webpage records you require;
        </p>
        <p style={style}>
          (3) This application obtains user personal data from business partners
          through legal means. You understand and agree that the following
          information does not apply to this privacy policy:
        </p>
        <p style={style}>
          a. The keyword information you enter when using the search service
          provided by this application platform;
        </p>
        <p style={style}>
          b. The relevant information and data that you publish in this
          application collected by this application, including but not limited
          to participation in activities, transaction information and evaluation
          details;
        </p>
        <p style={style}>
          c. Violation of legal provisions or violations of the rules of this
          application and the measures that this application has taken against
          you.
        </p>
        <p style={style} className="bold self-top--little">
          2. Use of information
        </p>
        <p style={style}>
          (1) This app will not provide, sell, rent, share or trade your
          personal information to any unrelated third party, unless you get your
          permission in advance, or the third party and this app (including this
          app affiliate) individually or jointly To provide you with services,
          and after the end of the service, it will be prohibited from accessing
          all these materials that it was able to access before.
        </p>
        <p style={style}>
          (2) This application also does not allow any third party to collect,
          edit, sell or disseminate your personal information by any means. If
          any user of this application platform engages in the above activities,
          once discovered, this application has the right to immediately
          terminate the service agreement with the user.
        </p>
        <p style={style}>
          (3) For the purpose of serving users, this application may use your
          personal information to provide you with information that you are
          interested in, including but not limited to sending you product and
          service information, or sharing information with the application
          partners for them Send you information about its products and services
          (the latter requires your prior consent).
        </p>
        <p style={style} className="bold self-top--little">
          3. Information disclosure
        </p>
        <p style={style}>
          Under the following circumstances, this application will disclose your
          personal information in whole or in part according to your personal
          wishes or legal requirements:
        </p>
        <p style={style}>
          (1) Disclosure to a third party with your prior consent;
        </p>
        <p style={style}>
          (2) In order to provide the products and services you request, you
          must share your personal information with third parties;
        </p>
        <p style={style}>
          (3) Disclosure to a third party or administrative or judicial
          organization in accordance with the relevant provisions of the law or
          the requirements of an administrative or judicial organization;
        </p>
        <p style={style}>
          (4) If you violate relevant Chinese laws, regulations or this
          application service agreement or related rules, you need to disclose
          to a third party;
        </p>
        <p style={style}>
          (5) If you are a qualified intellectual property complaint and have
          filed a complaint, you should disclose it to the respondent at the
          request of the respondent, so that both parties can deal with possible
          rights disputes;
        </p>
        <p style={style}>
          (6) In a transaction created on this application platform, if any
          party to the transaction fulfills or partially fulfills the
          transaction obligation and makes an information disclosure request,
          this application has the right to decide to provide the user with the
          contact information of the counterparty, etc. Information to
          facilitate the completion of the transaction or the resolution of
          disputes.
        </p>
        <p style={style}>
          (7) Other disclosures deemed appropriate by this application in
          accordance with laws, regulations or website policies.
        </p>
        <p style={style} className="bold self-top--little">
          4. Information storage and exchange
        </p>
        <p style={style}>
          The information and data collected by this application about you will
          be stored on the servers of this application and/or its affiliated
          companies. This information and data may be transmitted to your
          country, region or outside the country where the application collects
          information and data and is located in Visited, stored and displayed
          outside the country.
        </p>
        <p style={style} className="bold self-top--little">
          5. Use of Cookies
        </p>
        <p style={style}>
          (1) If you do not refuse to accept cookies, this application will set
          or access cookies on your computer so that you can log in or use the
          services or functions of this application platform that rely on
          cookies. This application uses cookies to provide you with more
          thoughtful and personalized services, including promotional services.
        </p>
        <p style={style}>
          (2) You have the right to choose to accept or refuse to accept
          cookies. You can refuse to accept cookies by modifying your browser
          settings. But if you choose to refuse to accept cookies, you may not
          be able to log in or use the web services or functions of this
          application that rely on cookies.
        </p>
        <p style={style}>
          (3) This policy will apply to the relevant information obtained
          through the cookies set in this application.
        </p>
        <p style={style} className="bold self-top--little">
          6. Information Security
        </p>
        <p style={style}>
          (1) This application account has security protection function, please
          keep your user name and password information properly. This
          application will use security measures such as encrypting user
          passwords to ensure that your information is not lost, abused and
          altered. Despite the aforementioned security measures, please also
          note that there is no "perfect security measure" on the information
          network.
        </p>
        <p style={style}>
          (2) When using this application network service to conduct online
          transactions, you will inevitably have to contact the counterparty or
          potential transaction pair
        </p>
        <p style={style} className="bold self-top--little">
          7. Changes to this privacy policy
        </p>
        <p style={style}>
          (1) If you decide to change the privacy policy, we will post these
          changes in this policy, on our company’s website and where we deem
          appropriate, so that you can understand how we collect and use your
          personal information and who can access this information. And under
          what circumstances we will disclose this information.
        </p>
        <p style={style}>
          (2) The company reserves the right to modify this policy at any time,
          so please check it frequently. If you make a major change to this
          policy, the company will notify you through a website notice.
        </p>
        <p style={style}>
          Please properly protect your personal information and only provide it
          to others when necessary. If you find that your personal information
          is leaked, especially the user name and password of this application,
          please contact the customer service of this application immediately so
          that this application can take corresponding measures.
        </p>
        <p style={style}>
          If you have any questions about this policy or other related matters,
          please contact us at http://www.techchina.org.cn/.
        </p>
      </div>
    </Modal>
  );
};

export default App;
